module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title1",
    attrs: {
      "id": "C3"
    }
  }, [_vm._v("Equipment")]), _vm._v(" "), _c('p', {
    staticClass: "intro1"
  }, [_vm._v("If you’ve found that designing cakes has become a bit of a passion, you will no doubt have accumulated a basic toolkit of equipment. These pages show what I use most often. I’ve divided the items up into categories, so you can see what is needed for each stage.")]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("A. FOR LAYERING, FILLING AND MASKING CAKES FOR A SHARP EDGE FINISH")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Serrated knife")]), _vm._v(" "), _c('li', [_vm._v("Offset spatula")]), _vm._v(" "), _c('li', [_vm._v("Paring knife")]), _vm._v(" "), _c('li', [_vm._v("Flat scraper with long blade")]), _vm._v(" "), _c('li', [_vm._v("Right-angled scraper or ruler")]), _vm._v(" "), _c('li', [_vm._v("Simple syrup, flavoured with liquor")]), _vm._v(" "), _c('li', [_vm._v("Ruler with millimetres (or "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("16")]), _vm._v("s of an inch)")]), _vm._v(" "), _c('li', [_vm._v("Flat palette knife")]), _vm._v(" "), _c('li', [_vm._v("Pastry brush")]), _vm._v(" "), _c('li', [_vm._v("Working board or food board")]), _vm._v(" "), _c('li', [_vm._v("Rigid cake boards such as silver-covered masonite")]), _vm._v(" "), _c('li', [_vm._v("Non-slip mat")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P9-1.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("B. FOR FONDANT COVERING")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("13. Rolling pin")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("14. Modelling tool such as soft blade or tapered end")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("15. Paring knife")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("16. Straight edged smoothers")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("17. Cornflour (cornstarch)")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("18. Non-slip mat")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("19. Acupuncture needles")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("20. Jam (jelly) syrup")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("21. Acetate buffers")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P9-2.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("C. FOR DECORATING")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("22. Silicone moulds")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("23. Culinary stencil")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("24. Pasta machine")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("25. Cake decorator’s alcohol (95% ethanol)")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("26. Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("27. Design knife or scalpel")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("28. Tweezers")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("29. Edible glaze spray")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("30. Tissues")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("31. Artist’s paintbrushes, different sizes")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("32. Edible pen")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("33. Hot glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("34. Pastry brushes")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("35. Edible marker")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P9-3.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("D. FOR FLOWER MAKING")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("36. Florist’s wires")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("37. Florist’s tape, Parafilm (plastic) and Floratape (crepe)")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("38. Cornflour (cornstarch)")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("39. Petal pad")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("40. Sugar glue")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("41. Foam balls")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("42. Silicone moulds for flower centres")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("43. Petal and leaf impression mats")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("44. Petal dusts")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("45. Cutters including flower, leaf and circles")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("46. Frilling tool")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("47. Paintbrushes and fluffy dusting brushes")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("48. Balling tool")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("49. Paring knife")]), _vm._v(" "), _c('p', {
    staticClass: "para-list"
  }, [_vm._v("50. Small rolling pin")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P9-4.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a104c7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter3.vue
// module id = 69
// module chunks = 0